import { photo } from '../artKit';

// Photos of the design families (Unsplash, free to use), sized at the catalog's request
// size. Most are landscape: the templates steer the crop with focus_x / focus_y.
export const PHOTOS = {
  squatRack: photo('1541534741688-6078c6bfb5c5', 1600, 1068),
  barbellBack: photo('1574680178050-55c6a6a96e0a', 1600, 1068),
  barbellMono: photo('1574680096145-d05b474e2155', 1600, 1068),
  dumbbellRow: photo('1546483875-ad9014c88eba', 1600, 1188),
  pushUp: photo('1594737625785-a6cbdabd333c', 1600, 1068),
  coaching: photo('1571019614242-c5c5dee9f50b', 1600, 1067),
  deadliftFloor: photo('1517963879433-6ad2b056d712', 1600, 1067),
  cable: photo('1507398941214-572c25f4b1dc', 1600, 1201),
  curl: photo('1581009146145-b5ef050c2e1e', 1600, 1067),
  legsStairs: photo('1538805060514-97d9cc17730c', 1600, 2400),
  runnerLegs: photo('1571008887538-b36bb32f4571', 1600, 1067),
  runnerSunset: photo('1594882645126-14020914d58d', 1600, 1049),
  runnerRoad: photo('1486218119243-13883505764c', 1600, 1065),
  runnerHill: photo('1530143311094-34d807799e8f', 1600, 1068),
  sprintStart: photo('1461896836934-ffe607ba8211', 1600, 1067),
  nightRun: photo('1552674605-db6ffd4facb5', 1600, 1067),
  classGroup: photo('1518310383802-640c2de311b2', 1600, 1067),
  yogaPose: photo('1575052814086-f385e2e2ad1b', 1600, 1067),
  yogaSeated: photo('1510894347713-fc3ed6fdf539', 1600, 1067),
  yogaClass: photo('1588286840104-8957b019727f', 1600, 1067),
  plank: photo('1599447421416-3414500d18a5', 1600, 1067),
  swim: photo('1530549387789-4c1017266635', 1600, 1067),
  cycling: photo('1517649763962-0c623066013b', 1600, 1067),
  football: photo('1579952363873-27f3bade9f55', 1600, 2133),
  basketball: photo('1546519638-68e109498ffc', 1600, 1044),
  tennis: photo('1622279457486-62dcc4a431d6', 1600, 1067),
  greenJuice: photo('1610970881699-44a5587cabec', 1600, 2400),
  smoothies: photo('1622597467836-f3285f2131b8', 1600, 900),
  blueberries: photo('1502741338009-cac2772e18bc', 1600, 1068),
  bowl: photo('1511690656952-34342bb7c2f2', 1600, 2000),
  fruitPlate: photo('1490474418585-ba9bad8fd0ea', 1600, 1067),
  fruits: photo('1610832958506-aa56368176cf', 1600, 1067),
  gear: photo('1584735935682-2f2b69dff9d2', 1600, 1067),
};
